import React from 'react';
import { motion, useScroll, useTransform, useReducedMotion } from 'framer-motion';
import { emotionalQuestions } from '../data/site';
export function Questions() {
  const {
    scrollYProgress
  } = useScroll();
  const reduce = useReducedMotion();
  const bgY = useTransform(scrollYProgress, [0, 1], [-60, reduce ? -60 : 60]);
  return <section className="relative w-full overflow-hidden bg-ink py-16 sm:py-24" data-id="element-121" data-mp="38d72fttfi9fo">
      <motion.img src="https://cdn.magicpatterns.com/patterns/generated-images/29abb180-dd0e-4a61-b752-1d4bcb96e069.jpg" alt="" aria-hidden="true" style={{
      y: bgY
    }} className="absolute inset-0 h-[130%] w-full scale-105 object-cover opacity-40 blur-sm" data-id="element-122" data-mp="3d9nrcq8gcrtt" />
      <div className="absolute inset-0 bg-ink/75" data-id="element-123" data-mp="3r12aqy69uv1e" />
      <div className="absolute inset-x-0 top-0 h-24 bg-gradient-to-b from-ink to-transparent" data-id="element-124" data-mp="3r3yb0t5ldvt0" />
      <div className="absolute inset-x-0 bottom-0 h-24 bg-gradient-to-t from-plum-deep to-transparent" data-id="element-125" data-mp="3vzdkl8wkh5jm" />

      <div className="relative mx-auto max-w-4xl px-5 text-center" data-id="element-126" data-mp="2cox1j2ecu7gb">
        <ul className="space-y-9 sm:space-y-12" data-id="element-127" data-mp="2cq84x13w1d6w">
          {emotionalQuestions.map((question, i) => <motion.li key={question} initial={{
          opacity: 0,
          y: 34,
          filter: 'blur(6px)'
        }} whileInView={{
          opacity: 1,
          y: 0,
          filter: 'blur(0px)'
        }} viewport={{
          once: true,
          amount: 0.6
        }} transition={{
          duration: 0.75,
          delay: i * 0.12,
          ease: [0.23, 1, 0.32, 1]
        }} className="font-serif text-3xl leading-snug text-white sm:text-4xl lg:text-5xl" data-id="element-128" data-mp="27oivfpwbd7kx" data-mpi={i}>
              {question}
              <span aria-hidden="true" className="mx-auto mt-6 block h-px w-16 bg-gold/40" data-id="element-129" data-mp="2lojuczt0q4xr" />
            </motion.li>)}
        </ul>
      </div>
    </section>;
}